import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Height, Label, Padding } from '@mui/icons-material';
import "./addressModal.css";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Grid, TextField } from '@mui/material';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "50rem",
    height: '40rem',
    bgcolor: 'background.paper',
    border: '',
    boxShadow: 24,
    p: 4,
};

const AddressModal = ({ open, handleClose, handleOpen }) => {
    const [age, setAge] = React.useState('');
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    return (
        <div>

            <Modal
                open={open}
                className=''
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="ch-address">
                    <Grid container spacing={{ xs: 2, md: 3 }} rowGap={{ xs: 2, sm: 2, md: 2 }}>
                        <Grid container display={"flex"} flexDirection={"column"}>
                            <Grid xs className=' lg:mt-2 ' container justifyContent={"center"}>
                                <Typography variant='h4'>
                                    Add New Address
                                </Typography>
                            </Grid>
                            <Grid xs className=' lg:mt-2 lg:w-[4rem] ' container justifyContent={"right"} >
                                <Typography variant='body1' className='shp-add'>
                                    Shipping Address
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container rowGap={{ xs: 2, sm: 2, md: 2 }} className='lg:mt-[3rem]' >
                            <Grid className='' xs={12} sm={2} md={12} container justifyContent="center">
                                <TextField className='lg:w-[35rem] w-[22rem]' label="Address 1" />
                            </Grid>
                            <Grid xs={12} sm={4} md={12} container justifyContent="center">
                                <TextField className='lg:w-[35rem] w-[22rem]' label="Address 2" />
                            </Grid>
                            <Grid xs={5} sm={4} md={5} container justifyContent="center" className='state' textAlign={"right"} >
                                <TextField className='lg:w-[7rem] w-[6rem]' label="State" type='text' />
                            </Grid>
                            <Grid xs={2} sm={4} md={2} container justifyContent="center" textAlign={"center"} >
                                <TextField className='lg:w-[13rem]' label="City" type='text' />
                            </Grid>
                            <Grid xs={5} sm={4} md={5} container justifyContent="center" className='zipcode' textAlign={"left"}>
                                <TextField className='lg:w-[7rem] w-[6rem]' label="Zip Code" type='text' />
                            </Grid>
                            <Grid className='' xs={6} sm={4} md={6} justifyContent="center" textAlign={"right"}>
                                <TextField label="Email Address" className='lg:w-[17.5rem] w-[11rem]' />
                            </Grid>
                            <Grid className='lg:pl-4 pl-2' xs={6} sm={4} md={6} justifyContent="center" textAlign={"left"}>
                                <TextField type='tel' label="Phone Number" className='lg:w-[16.5rem] w-[11rem]' />
                            </Grid>
                        </Grid>
                        <Grid container className='lg:mt-[4rem] mt-[4rem]' justifyContent={"center"} textAlign={"center"}>
                            <Grid >
                                <Button
                                    className="ad-cancel "
                                    onClick={handleClose}
                                    variant=""
                                    type="submit"
                                    sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", border: 'solid 1px', color: '#1976d2' }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid>
                                <Button
                                    className="ad-continue"

                                    variant=""
                                    sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", marginLeft: "1rem", border: 'solid 1px', color: '#1976d2' }}
                                >
                                    Continue
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>



                    {/* <div onClick={handleClose}>Close</div> */}
                </Box>
            </Modal>
        </div>
    )
}

export default AddressModal